import React from 'react'
import { Route, Routes } from 'react-router-dom'
import CalendarPage from './components/CalendarPage/CalendarPage'
import ContactPage from './components/ContactPage/ContactPage'
import HistoryPage from './components/HistoryPage/HistoryPage'
import InfoPage from './components/InfoPage/InfoPage'
import Layout from './components/Layout/Layout'
import PicturesPage from './components/PicturesPage/PicturesPage'

function App() {
  return (
    <Layout>
      <Routes>
        <Route path='/' element={<InfoPage />} />
        <Route path='/historia' element={<HistoryPage />} />
        <Route path='/kuvia' element={<PicturesPage />} />
        <Route path='/kalenteri' element={<CalendarPage />} />
        <Route path='/yhteystiedot' element={<ContactPage />} />
      </Routes>
    </Layout>
  )
}

export default App
